import { pixel } from 'constants/device'
import { intfc_prefix_common, govUrl, client_ver } from 'constants/project'

const defaults = {
	client_ver,
	device_size: pixel
};

function getAjaxPromise(opts) {
  console.log(opts);
	const url_prefix= intfc_prefix_common;
	const url = url_prefix + opts.url;
	const type = opts.type || 'GET';
	const data = $.extend({}, opts.params);
	const dataType = opts.dataType || 'json';
	return $.ajax({
		type,
		url,
		data,
		dataType
	});
}
function getGovAjaxPromise(opts) {
  console.log(opts);
	const url_prefix= govUrl;
	const url = url_prefix + opts.url;
	const type = opts.type || 'GET';
	const data = $.extend({}, opts.params);
	const dataType = opts.dataType || 'json';
	return $.ajax({
		type,
		url,
		data,
		dataType
	});
}

export function getHotComments(params) {
	params['count'] = 5;
	// const url = '/api/anon/article/1';
	// return getAjaxPromise({ url });
}
//单条评论
export function getCommentDetail(params) {
	let url = '/comment/commentdetail';
	return getAjaxPromise({url, params});
}

export function getSubjectList(params) {
	const url = '/api/v2/subjects/'+params.articleId;
	return getAjaxPromise({ url,params});
}
//专题区块列表
export function getTopicBlockList(params) {
	const url = '/api/v2/blocks/'+params.articleId;
	return getAjaxPromise({ url, params });
}

export function getDetail(params) {
	const url = '/api/v2/articles/detail/'+params.articleId;
	return getAjaxPromise({ url });
}
export function getDetailPreview(params) {
	const url = '/api/v2/articles/detailPreview/'+params.articleId;
	return getAjaxPromise({ url });
}
export function getDetailGov(params) {
	const url = '/api/v2/articles/info/'+params.articleId;
	return getGovAjaxPromise({ url });
}

export function getLiveDetail(params) {
	const url = '/api/v2/live/detail/'+params.articleId;
	return getAjaxPromise({ url, params });
}

export function getLive(params) {
	const url = '/api/v2/live/liveRoomTalk';
	return getAjaxPromise({ url, params});
}
export function getLiveComments(params) {
	const url = '/api/v2/live/liveRoomComment';
	return getAjaxPromise({ url, params});
}
export function getAskDetail(params) {
	const url = '/ask/detail';
	return getAjaxPromise({ url, params });
}

export function getAskRelated(params) {
	const url = '/ask/related';
	return getAjaxPromise({ url, params });
}

export function getAskTopic(params) {
	const url = '/ask/topicdetail';
	return getAjaxPromise({ url, params});
}
export function getPagerDetail(params){
	const url='';
	//const url_prefix='http://vapi.people.cn/prod/common/api/paper/paperdetail.php'
	const url_prefix='http://vweb.people.cn/test/common/api/paper/paperdetail.php'
	return getAjaxPromise({url_prefix, url, params});
}



// WEBPACK FOOTER //
// ./src/services/api.js